import RoutesUtils from './../../js/RoutesUtils.js';

/**
 * Quién puede abrir **OEE › Autorizaciones** (#905). Una sola respuesta, que usan su ruta, la
 * tarjeta del menú de FACTURACIÓN y el enlace del bloque «Condiciones de facturación», para que no
 * contesten cosas distintas (el precedente, en `permisos-control-planificacion.js`).
 *
 * **Manda el menú de Mongo, no el rol** (`CLAUDE.md` §9 del orquestador): el punto de entrada se
 * dibuja si y solo si la ruta está en el menú efectivo. La lista de roles solo decide mientras el
 * menú no está cargado, y es la de FACTURACIÓN hoy. Quien autoriza no lo decide esto: lo decide la
 * API con el permiso «autoriza», y a quien entra sin él la pantalla le dice por qué no puede.
 */
export const ROLES_AUTORIZACIONES = ['ADMIN', 'DIRECTOR'];

export const RUTA_AUTORIZACIONES = '/dashboard/facturacion/autorizaciones/';

export function puedeAbrirAutorizaciones() {
    return RoutesUtils.tieneAcceso(RUTA_AUTORIZACIONES, ROLES_AUTORIZACIONES);
}

export default {
    ROLES_AUTORIZACIONES,
    RUTA_AUTORIZACIONES,
    puedeAbrirAutorizaciones
};
